import React from "react";
import logo from "../../../Assets/logo.svg";

function Logo() {
  return <img src={logo} alt="" />;
}

export default Logo;
